/**
 * EastSupplier homepage hero — digital ocean & container fleet
 */
(function () {
  'use strict';

  function initHeroCanvas(root) {
    if (root.dataset.esCanvasInit === '1') return;
    root.dataset.esCanvasInit = '1';

    var canvas = root.querySelector('[data-hero-canvas]');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var width = 0;
    var height = 0;
    var layState = { lastW: 0, lastH: 0 };
    var time = 0;
    var rafId = null;
    var running = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var clouds = [];
    var gridNodes = [];
    var containers = [];
    var arcs = [];

    function rand(min, max) {
      return min + Math.random() * (max - min);
    }

    function buildClouds() {
      clouds = [];
      var count = Math.max(5, Math.floor(width / 220));
      for (var i = 0; i < count; i++) {
        clouds.push({
          x: rand(0, width),
          y: rand(height * 0.04, height * 0.32),
          scale: rand(0.55, 1.35),
          speed: rand(0.08, 0.22) * (Math.random() > 0.5 ? 1 : -1),
          opacity: rand(0.45, 0.92)
        });
      }
    }

    function buildGrid() {
      gridNodes = [];
      arcs = [];
      var cols = Math.max(8, Math.floor(width / 90));
      var rows = Math.max(4, Math.floor((height * 0.42) / 55));
      var oceanTop = height * 0.48;

      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < cols; c++) {
          gridNodes.push({
            x: (c / (cols - 1)) * width,
            y: oceanTop + (r / (rows - 1)) * height * 0.42 + rand(-8, 8),
            phase: rand(0, Math.PI * 2),
            size: rand(1.2, 2.4)
          });
        }
      }

      for (var a = 0; a < Math.min(18, Math.floor(width / 120)); a++) {
        var n1 = gridNodes[Math.floor(Math.random() * gridNodes.length)];
        var n2 = gridNodes[Math.floor(Math.random() * gridNodes.length)];
        if (n1 && n2 && n1 !== n2) {
          arcs.push({ from: n1, to: n2, phase: rand(0, Math.PI * 2) });
        }
      }
    }

    function buildContainers() {
      containers = [];
      var count = Math.max(4, Math.floor(width / 260));
      var oceanY = height * 0.58;

      for (var i = 0; i < count; i++) {
        var scale = rand(0.55, 1.15);
        containers.push({
          x: (i / Math.max(1, count - 1)) * width * 1.15 - width * 0.08,
          baseY: oceanY + rand(-12, 28),
          scale: scale,
          speed: rand(0.12, 0.28),
          bob: rand(0, Math.PI * 2),
          bobSpeed: rand(0.6, 1.1),
          colors: pickContainerColors(i),
          depth: rand(0.35, 1)
        });
      }
    }

    function pickContainerColors(index) {
      var palettes = [
        ['#c73d23', '#8f2a18', '#e85a3f'],
        ['#1e5f9c', '#143f6b', '#3a8fd4'],
        ['#8b5a2b', '#5c3b1a', '#a87442'],
        ['#2d6b4f', '#1d4534', '#4a9a72']
      ];
      return palettes[index % palettes.length];
    }

    function resize() {
      var L = window.EastSupplierCanvasLayout;
      if (L) {
        var m = L.measure(canvas, root, { minW: 320, minH: 280, state: layState });
        width = m.w;
        height = m.h;
        dpr = m.dpr;
        L.applyBitmap(canvas, ctx, width, height, dpr);
      } else {
        var rect = (canvas.parentElement || root).getBoundingClientRect();
        width = Math.max(320, rect.width);
        height = Math.max(280, rect.height);
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.floor(width * dpr);
        canvas.height = Math.floor(height * dpr);
        if (canvas.style) {
          canvas.style.width = '';
          canvas.style.height = '';
        }
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      buildClouds();
      buildGrid();
      buildContainers();
    }

    function drawSky() {
      var g = ctx.createLinearGradient(0, 0, 0, height);
      g.addColorStop(0, '#8ec8f4');
      g.addColorStop(0.38, '#b8dcf8');
      g.addColorStop(0.62, '#5eb0e8');
      g.addColorStop(1, '#1a6eb5');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, width, height);

      var sun = ctx.createRadialGradient(width * 0.78, height * 0.14, 0, width * 0.78, height * 0.14, width * 0.22);
      sun.addColorStop(0, 'rgba(255, 255, 255, 0.55)');
      sun.addColorStop(1, 'rgba(255, 255, 255, 0)');
      ctx.fillStyle = sun;
      ctx.fillRect(0, 0, width, height);
    }

    function drawCloud(cloud) {
      var x = cloud.x;
      var y = cloud.y;
      var s = 34 * cloud.scale;

      ctx.save();
      ctx.globalAlpha = cloud.opacity;
      ctx.fillStyle = '#ffffff';

      function puff(px, py, r) {
        ctx.beginPath();
        ctx.arc(px, py, r, 0, Math.PI * 2);
        ctx.fill();
      }

      puff(x, y, s * 0.55);
      puff(x - s * 0.55, y + s * 0.08, s * 0.42);
      puff(x + s * 0.5, y + s * 0.05, s * 0.46);
      puff(x + s * 0.15, y - s * 0.2, s * 0.38);
      ctx.restore();
    }

    function drawClouds(dt) {
      clouds.forEach(function (cloud) {
        if (!reducedMotion) cloud.x += cloud.speed * dt * 18;
        if (cloud.x < -120) cloud.x = width + 120;
        if (cloud.x > width + 120) cloud.x = -120;
        drawCloud(cloud);
      });
    }

    function oceanSurfaceY(x) {
      var base = height * 0.52;
      return (
        base +
        Math.sin(x * 0.008 + time * 0.9) * 10 +
        Math.sin(x * 0.018 + time * 1.4) * 5
      );
    }

    function drawDigitalOcean() {
      var oceanTop = height * 0.48;

      var og = ctx.createLinearGradient(0, oceanTop, 0, height);
      og.addColorStop(0, 'rgba(12, 92, 168, 0.55)');
      og.addColorStop(0.35, 'rgba(8, 72, 140, 0.82)');
      og.addColorStop(1, 'rgba(4, 38, 88, 0.96)');
      ctx.fillStyle = og;
      ctx.fillRect(0, oceanTop, width, height - oceanTop);

      ctx.save();
      ctx.strokeStyle = 'rgba(120, 210, 255, 0.12)';
      ctx.lineWidth = 1;
      var gridStep = 42;
      for (var gx = 0; gx <= width; gx += gridStep) {
        ctx.beginPath();
        ctx.moveTo(gx, oceanTop);
        ctx.lineTo(gx - width * 0.08, height);
        ctx.stroke();
      }
      for (var gy = oceanTop; gy <= height; gy += gridStep * 0.75) {
        ctx.beginPath();
        ctx.moveTo(0, gy);
        ctx.lineTo(width, gy + 18);
        ctx.stroke();
      }
      ctx.restore();

      ctx.save();
      ctx.beginPath();
      ctx.moveTo(0, oceanSurfaceY(0));
      for (var x = 0; x <= width; x += 8) {
        ctx.lineTo(x, oceanSurfaceY(x));
      }
      ctx.lineTo(width, height);
      ctx.lineTo(0, height);
      ctx.closePath();
      var wg = ctx.createLinearGradient(0, oceanTop, 0, height);
      wg.addColorStop(0, 'rgba(46, 160, 230, 0.35)');
      wg.addColorStop(1, 'rgba(8, 48, 110, 0.9)');
      ctx.fillStyle = wg;
      ctx.fill();
      ctx.restore();

      arcs.forEach(function (arc) {
        var pulse = 0.35 + 0.25 * Math.sin(time * 1.6 + arc.phase);
        ctx.save();
        ctx.strokeStyle = 'rgba(130, 220, 255, ' + pulse * 0.35 + ')';
        ctx.lineWidth = 1;
        ctx.beginPath();
        var mx = (arc.from.x + arc.to.x) / 2;
        var my = (arc.from.y + arc.to.y) / 2 - 30;
        ctx.moveTo(arc.from.x, arc.from.y);
        ctx.quadraticCurveTo(mx, my, arc.to.x, arc.to.y);
        ctx.stroke();
        ctx.restore();
      });

      gridNodes.forEach(function (node) {
        var bob = Math.sin(time * 1.2 + node.phase) * 3;
        var glow = 0.35 + 0.35 * Math.sin(time * 2 + node.phase);
        ctx.beginPath();
        ctx.fillStyle = 'rgba(160, 230, 255, ' + glow + ')';
        ctx.arc(node.x, node.y + bob, node.size, 0, Math.PI * 2);
        ctx.fill();
      });
    }

    function drawFlagship() {
      var baseX = width * 0.72;
      var baseY = height * 0.54 + Math.sin(time * 0.7) * 6;
      var scale = Math.min(width / 1200, 1.15);

      ctx.save();
      ctx.globalAlpha = 0.92;
      ctx.translate(baseX, baseY);
      ctx.scale(scale, scale);

      var stacks = [
        { colors: ['#c73d23', '#8f2a18', '#e85a3f'], count: 4, ox: 0 },
        { colors: ['#1e5f9c', '#143f6b', '#3a8fd4'], count: 3, ox: 95 },
        { colors: ['#8b5a2b', '#5c3b1a', '#a87442'], count: 3, ox: 175 }
      ];

      stacks.forEach(function (stack) {
        for (var i = 0; i < stack.count; i++) {
          var w = 82;
          var h = 32;
          var by = -i * (h * 0.82);
          ctx.save();
          ctx.translate(stack.ox, 0);
          ctx.fillStyle = stack.colors[1];
          ctx.fillRect(0, by, w, h);
          ctx.fillStyle = stack.colors[0];
          ctx.fillRect(0, by, w, h * 0.72);
          ctx.fillStyle = stack.colors[2];
          ctx.beginPath();
          ctx.moveTo(w, by);
          ctx.lineTo(w + w * 0.1, by + h * 0.14);
          ctx.lineTo(w + w * 0.1, by + h);
          ctx.lineTo(w, by + h);
          ctx.closePath();
          ctx.fill();
          ctx.restore();
        }
      });

      ctx.fillStyle = 'rgba(20, 55, 95, 0.85)';
      ctx.beginPath();
      ctx.moveTo(-30, 8);
      ctx.lineTo(280, 8);
      ctx.lineTo(300, 38);
      ctx.lineTo(-50, 38);
      ctx.closePath();
      ctx.fill();

      ctx.restore();
    }

    function drawContainer(item) {
      var w = 88 * item.scale;
      var h = 34 * item.scale;
      var stack = 3;
      var x = item.x;
      var y = item.baseY + Math.sin(time * item.bobSpeed + item.bob) * (8 * item.depth);

      if (!reducedMotion) item.x += item.speed * item.depth;

      if (item.x > width + w * 2) item.x = -w * 2;

      ctx.save();
      ctx.globalAlpha = 0.55 + item.depth * 0.4;
      ctx.translate(x, y);

      for (var s = 0; s < stack; s++) {
        var colors = item.colors;
        var bw = w * (0.92 - s * 0.06);
        var bh = h;
        var by = -s * (h * 0.82);

        ctx.fillStyle = colors[1];
        ctx.fillRect(0, by, bw, bh);

        ctx.fillStyle = colors[0];
        ctx.fillRect(0, by, bw, bh * 0.72);

        ctx.fillStyle = colors[2];
        ctx.beginPath();
        ctx.moveTo(bw, by);
        ctx.lineTo(bw + bw * 0.12, by + bh * 0.15);
        ctx.lineTo(bw + bw * 0.12, by + bh);
        ctx.lineTo(bw, by + bh);
        ctx.closePath();
        ctx.fill();

        ctx.fillStyle = 'rgba(255,255,255,0.18)';
        ctx.fillRect(bw * 0.08, by + bh * 0.2, bw * 0.12, bh * 0.45);
        ctx.fillRect(bw * 0.28, by + bh * 0.2, bw * 0.12, bh * 0.45);
      }

      ctx.restore();
    }

    function drawHorizonGlow() {
      var g = ctx.createLinearGradient(0, height * 0.42, 0, height * 0.58);
      g.addColorStop(0, 'rgba(255,255,255,0)');
      g.addColorStop(0.5, 'rgba(200, 235, 255, 0.25)');
      g.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = g;
      ctx.fillRect(0, height * 0.4, width, height * 0.22);
    }

    var lastTs = 0;

    function frame(ts) {
      if (!running) return;
      var expectedW = Math.max(1, Math.floor(width * dpr));
      if (canvas.width < expectedW * 0.5 || canvas.height < Math.max(1, Math.floor(height * dpr)) * 0.5) {
        resize();
      }
      var dt = lastTs ? (ts - lastTs) / 1000 : 0.016;
      lastTs = ts;
      if (!reducedMotion) time += dt;

      ctx.clearRect(0, 0, width, height);
      drawSky();
      drawClouds(dt);
      drawHorizonGlow();
      drawDigitalOcean();

      var sorted = containers.slice().sort(function (a, b) {
        return a.depth - b.depth;
      });
      sorted.forEach(drawContainer);
      drawFlagship();

      rafId = window.requestAnimationFrame(frame);
    }

    function start() {
      if (running) return;
      resize();
      running = true;
      lastTs = 0;
      rafId = window.requestAnimationFrame(frame);
    }

    function stop() {
      running = false;
      if (rafId) window.cancelAnimationFrame(rafId);
    }

    resize();
    window.addEventListener('resize', resize);

    if (typeof ResizeObserver !== 'undefined' && canvas.parentElement) {
      new ResizeObserver(function () {
        resize();
      }).observe(canvas.parentElement);
    }

    requestAnimationFrame(function () {
      resize();
    });

    start();

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              resize();
              start();
            } else stop();
          });
        },
        { rootMargin: '80px', threshold: 0 }
      );
      observer.observe(root);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else {
        resize();
        if (root.getBoundingClientRect().bottom > 0 && root.getBoundingClientRect().top < window.innerHeight) start();
      }
    });

    window.addEventListener('pageshow', function () {
      resize();
      start();
    });
  }

  function boot() {
    document.querySelectorAll('[data-eastsupplier-hero]').forEach(initHeroCanvas);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
